import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const OpportunityFormDialog = ({ isOpen, onOpenChange, formData, setFormData, isEditMode, onSave, isDemo }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-['Barlow_Condensed'] uppercase">
            {isEditMode ? "Edit Opportunity" : "Add Opportunity"}
          </DialogTitle>
          <DialogDescription>Add a custom investment opportunity to track</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label>Category</Label>
            <Select value={formData.category} onValueChange={(v) => setFormData({ ...formData, category: v })}>
              <SelectTrigger data-testid="opp-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="defi">DeFi</SelectItem>
                <SelectItem value="web3_secondaries">Web3 Secondaries</SelectItem>
                <SelectItem value="stocks">Stocks</SelectItem>
                <SelectItem value="others">Others</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <Label>Name *</Label>
              <Input data-testid="opp-name-input" placeholder={formData.category === "defi" ? "e.g., Aave USDC Lending" : "e.g., Startup Alpha"} value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </div>

            {formData.category === "defi" && (
              <>
                <div><Label>Protocol</Label><Input placeholder="Aave, Compound" value={formData.protocol} onChange={(e) => setFormData({ ...formData, protocol: e.target.value })} /></div>
                <div><Label>Chain</Label><Input placeholder="Ethereum, Polygon" value={formData.chain} onChange={(e) => setFormData({ ...formData, chain: e.target.value })} /></div>
                <div><Label>APY (%)</Label><Input data-testid="opp-apy-input" type="number" step="0.01" placeholder="5.5" value={formData.apy} onChange={(e) => setFormData({ ...formData, apy: e.target.value })} /></div>
                <div><Label>TVL (USD)</Label><Input type="number" placeholder="1000000" value={formData.tvl} onChange={(e) => setFormData({ ...formData, tvl: e.target.value })} /></div>
                <div><Label>Token</Label><Input placeholder="USDC, ETH" value={formData.token} onChange={(e) => setFormData({ ...formData, token: e.target.value.toUpperCase() })} /></div>
              </>
            )}

            {formData.category !== "defi" && (
              <>
                <div className="col-span-2"><Label>Description</Label><Input placeholder="Brief description..." value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} data-testid="opp-description-input" /></div>
                <div><Label>Type (free text)</Label><Input placeholder="e.g., SAFT, Equity, ETF" value={formData.custom_type} onChange={(e) => setFormData({ ...formData, custom_type: e.target.value })} data-testid="opp-type-input" /></div>
                <div><Label>Expected Return</Label><Input placeholder="e.g., 15% p.a." value={formData.expected_return} onChange={(e) => setFormData({ ...formData, expected_return: e.target.value })} data-testid="opp-return-input" /></div>
                <div><Label>Price</Label><Input placeholder="e.g., $150" value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} /></div>
                <div><Label>Ticket Min</Label><Input placeholder="e.g., $10,000" value={formData.ticket} onChange={(e) => setFormData({ ...formData, ticket: e.target.value })} /></div>
                <div>
                  <Label>Currency</Label>
                  <Select value={formData.currency} onValueChange={(v) => setFormData({ ...formData, currency: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="USD">USD</SelectItem>
                      <SelectItem value="EUR">EUR</SelectItem>
                      <SelectItem value="GBP">GBP</SelectItem>
                      <SelectItem value="BTC">BTC</SelectItem>
                      <SelectItem value="ETH">ETH</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div><Label>Contact</Label><Input placeholder="email or link" value={formData.contact} onChange={(e) => setFormData({ ...formData, contact: e.target.value })} /></div>
                <div><Label>Image URL</Label><Input placeholder="https://..." value={formData.image_url} onChange={(e) => setFormData({ ...formData, image_url: e.target.value })} /></div>
                <div className="col-span-2"><Label>Notes</Label><Input placeholder="Additional notes..." value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} /></div>
              </>
            )}

            <div><Label>URL (optional)</Label><Input placeholder="https://..." value={formData.url} onChange={(e) => setFormData({ ...formData, url: e.target.value })} /></div>
            <div className={formData.category === "defi" ? "" : "col-span-1"}>
              <Label>Risk Score: {formData.risk_score}</Label>
              <Slider value={[formData.risk_score]} onValueChange={([v]) => setFormData({ ...formData, risk_score: v })} max={100} step={1} className="mt-2" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} data-testid="save-opportunity-btn" className="bg-primary text-primary-foreground">
            {isEditMode ? "Update" : "Add Opportunity"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
